/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocCheckIcon16Light } from './DocCheckIcon16Light';
import { DocCheckIcon16Regular } from './DocCheckIcon16Regular';
import { DocCheckIcon16Solid } from './DocCheckIcon16Solid';
import { DocCheckIcon20Light } from './DocCheckIcon20Light';
import { DocCheckIcon20Regular } from './DocCheckIcon20Regular';
import { DocCheckIcon20Solid } from './DocCheckIcon20Solid';
import { DocCheckIcon24Regular } from './DocCheckIcon24Regular';
import { DocCheckIcon24Solid } from './DocCheckIcon24Solid';
import { DocCheckIcon32Regular } from './DocCheckIcon32Regular';
import { DocCheckIcon64Regular } from './DocCheckIcon64Regular';
var sizes = {
    16: {
        light: DocCheckIcon16Light,
        regular: DocCheckIcon16Regular,
        solid: DocCheckIcon16Solid,
    },
    20: {
        light: DocCheckIcon20Light,
        regular: DocCheckIcon20Regular,
        solid: DocCheckIcon20Solid,
    },
    24: {
        regular: DocCheckIcon24Regular,
        solid: DocCheckIcon24Solid,
    },
    32: {
        regular: DocCheckIcon32Regular,
    },
    64: {
        regular: DocCheckIcon64Regular,
    },
};
export var DocCheckIcon = forwardRef('DocCheckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
